import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { IIncidence, ISummaryCalculate } from 'modules/sales/incidence/interfaces';
import { INCIDENCE_STATUS_ENUM } from '../constants/incidence-status';

class IncidenceService extends EntityApiService<IIncidence> {
  updateStatus = (id: string, status: INCIDENCE_STATUS_ENUM) => {
    return ApiClientService.patch(this.getPath(`/${id}/status`), {
      status,
    });
  };

  changeAssignation = (incidenceId: string, assignedId: string): any => {
    return this.handleResponse(
      ApiClientService.patch(this.getPath(`/${incidenceId}/assigned`), {
        assigned: assignedId,
      }),
    );
  };

  searchComments = (incidenceId: string, params?: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${incidenceId}/comments/search`), params));
  };

  addComments = (incidenceId: string, params: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${incidenceId}/comments`), params));
  };

  addActions = (incidenceId: string, params: any) => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${incidenceId}/add-actions`), params));
  };

  addSolutions = (incidenceId: string, params: any, config?: RequestConfig) => {
    return this.handleResponse(
      ApiClientService.post(`/ms-sales/api/incidence-resolution/${incidenceId}/apply`, params, config),
    );
  };

  evaluate = (incidenceId: string, params: ISummaryCalculate) => {
    return this.handleResponse(
      ApiClientService.post(`/ms-sales/api/incidence-resolution/${incidenceId}/evaluate`, params),
    );
  };
}

export default new IncidenceService('/ms-sales/api/incidence');
